import { useTranslation } from 'react-i18next'
import step1Cs from '../../assets/img/step-1-cs.png'
import step1En from '../../assets/img/step-1-en.png'
import step1Uk from '../../assets/img/step-1-uk.png'
import step2Cs from '../../assets/img/step-2-cs.png'
import step2En from '../../assets/img/step-2-en.png'
import step2Uk from '../../assets/img/step-2-uk.png'
import step3Cs from '../../assets/img/step-3-cs.png'
import step3En from '../../assets/img/step-3-en.png'
import step3Uk from '../../assets/img/step-3-uk.png'
import step4Cs from '../../assets/img/step-4-cs.png'
import step4En from '../../assets/img/step-4-en.png'
import step4Uk from '../../assets/img/step-4-uk.png'
import { ButtonElement, ButtonLocation, trackButtonClick } from '../../utils/analyticsEvents'
import { Button } from '../Button/Button'
import { LocalizedImage, type LocalizedImageSources } from '../LocalizedImage/LocalizedImage'
import { SectionHeading } from '../SectionHeading/SectionHeading'
import styles from './Steps.module.scss'

interface Step {
  sources: LocalizedImageSources
  key: string
}

const STEPS: Step[] = [
  { key: 'create', sources: { cs: step1Cs, en: step1En, uk: step1Uk } },
  { key: 'find', sources: { cs: step2Cs, en: step2En, uk: step2Uk } },
  { key: 'discount', sources: { cs: step3Cs, en: step3En, uk: step3Uk } },
  { key: 'scan', sources: { cs: step4Cs, en: step4En, uk: step4Uk } },
]

interface StepsProps {
  onSend: () => void
}

export const Steps = ({ onSend }: StepsProps) => {
  const { t } = useTranslation()

  return (
    <section className={styles.steps} id="how-it-works">
      <div className="container">
        <SectionHeading
          action={
            <Button
              animated
              arrow
              variant="outline"
              onClick={() => {
                trackButtonClick(ButtonElement.OpenInstruction, ButtonLocation.HowDoesItWork)
                onSend()
              }}
            >
              {t('steps.action')}
            </Button>
          }
          subtitle={t('steps.subtitle')}
          title={t('steps.title')}
        />
        <ol className={styles.grid}>
          {STEPS.map((step, index) => (
            <li key={step.key} className={styles.card}>
              <LocalizedImage
                alt=""
                className={styles.image}
                height="285"
                loading="lazy"
                sources={step.sources}
                width="608"
              />
              <div className={styles.caption}>
                <span aria-hidden className={styles.number}>
                  {index + 1}
                </span>
                <p className={styles.text}>{t(`steps.items.${step.key}`)}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
    </section>
  )
}
